import { call, takeEvery, put } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import {
  fetchOrderDataAction,
  fetchOrderDataErrorAction,
  fetchOrderDataSuccessAction,
  setErrorAction,
  createShippingLabelAction,
  createShippingLabelSuccessAction,
  createShippingLabelErrorAction,
  setOpenModalAction
} from './reducer'
import { setServiceUnavailableMessage } from '../auth/reducer'
import { ordersApi } from '../../services/api/orders/'
import { ApiError } from '../../services/api/api-error-data'
import {trackException} from '../app-insights/reducer'
import { AxiosError } from 'axios'
import { HTTP_STATUS_CODES } from '../../settings/http'

//Get Order Page detail
export function* fetchOrderDetailSaga({
  payload,
}: ReturnType<typeof fetchOrderDataAction>): SagaIterator {
  try {
    const data = yield call(ordersApi.getOrderDetail, payload)
    yield put(fetchOrderDataSuccessAction({ ...data }))
  } catch (e) {
    yield put(fetchOrderDataErrorAction())
    yield put(setErrorAction(e as ApiError))
    yield put(trackException({e, source: 'fetchOrderDetailSaga'}))
  }
}

//Create Shipping Label
export function* createShippingLabelSaga({
  payload,
}: ReturnType<typeof createShippingLabelAction>): SagaIterator {
  try {
    const response = yield call(ordersApi.createShippingLabel, payload)
    yield put(createShippingLabelSuccessAction(response.data.shippingLabelUrl as string))
  } catch (reason) {
    const status = (reason as AxiosError)?.response?.status || null
    if (status === HTTP_STATUS_CODES.SERVICE_UNAVAILABLE) {
      yield put(setOpenModalAction(false))
      yield put(setServiceUnavailableMessage({
        serviceUnavailableMessage: 'Service Unavailable.Try again later'
      }))
      return
    }
    yield put(createShippingLabelErrorAction(reason as ApiError))
    yield put(trackException({e: reason, source: 'createShippingLabelSaga'}))
  }
}

export function* orderSaga(): SagaIterator {
  yield takeEvery(fetchOrderDataAction, fetchOrderDetailSaga)
  yield takeEvery(createShippingLabelAction, createShippingLabelSaga)
}
